import { Tooltip } from 'antd';
import React from 'react';
import { connect } from 'react-redux';
import { AppState } from 'src/config/appState';
import * as navigationActions from 'src/modules/navigation/actions/navigationActions';

import { WebExclusiveBadge } from 'src/modules/programs/components/WebExclusiveBadge';
import { ProgramEnum } from '../models/programs';
import {
    getProgramCardRedirectUrl,
    getProgramCardTooltip,
    getProgramCardWeeksLength,
} from '../selectors/programsCardsSelectors';
import { getProgramProgressPercentage, isProgramCompleted } from '../selectors/programsSelectors';
import * as S from './styles';

interface StateProps {
    programCompleted: boolean;
    progress: number;
    lengthInWeeks: string | undefined;
    tooltip: string | undefined;
    redirectUrl: string;
}

interface ActionsProps {
    redirectToUrl: typeof navigationActions.redirectToUrl;
}

interface Props extends StateProps, ActionsProps {
    programId: ProgramEnum;
    title: string;
    iconUrl: string;
    webExclusive?: boolean;
}

export const AdditionalProgramCardContainer: React.SFC<Props> = props => (
    <Tooltip placement="bottom" title={props.tooltip}>
        <S.CardWrapper onClick={() => props.redirectToUrl(props.redirectUrl)}>
            {props.webExclusive && <WebExclusiveBadge />}
            {props.programCompleted && <S.CompletedIcon />}
            <S.CardContent>
                <S.CardIcon iconUrl={props.iconUrl} />
                <S.CardTitle>{props.title}</S.CardTitle>
                <S.CardSmallInfo>{props.lengthInWeeks}</S.CardSmallInfo>
            </S.CardContent>
        </S.CardWrapper>
    </Tooltip>
);

const mapStateToProps = (state: AppState, { programId }: Props): StateProps => ({
    programCompleted: isProgramCompleted(state, programId),
    progress: getProgramProgressPercentage(state, programId),
    lengthInWeeks: getProgramCardWeeksLength(state, programId),
    tooltip: getProgramCardTooltip(state, programId),
    redirectUrl: getProgramCardRedirectUrl(state, programId),
});

export const AdditionalProgramCard = connect<StateProps, ActionsProps>(mapStateToProps, {
    redirectToUrl: navigationActions.redirectToUrl,
})(AdditionalProgramCardContainer);
